/* eslint camelcase: 0 */
import { Hits } from '@/infrastructure/network/Algolia/schema'
import { EmptyQueryPropsFactory, IQueryProps } from '@/entities/Query'

export const toQueryProps = (props?: Hits): IQueryProps => {
  if (!props) {
    return EmptyQueryPropsFactory()
  }
  const { page, nbHits, nbPages, hitsPerPage } = props

  return EmptyQueryPropsFactory({
    total: nbHits,
    page,
    take: hitsPerPage,
    count: nbPages
  })
}

export const toHits = (props: IQueryProps): Hits => {
  const { page, take, query } = props
  return {
    page,
    hitsPerPage: take,
    filters: query || undefined
  }
}
